import { Cell } from "react-table";
import { CustomLinkModel } from "src/api/customLink/custom-link-types";
import { BaseToggle, BaseTooltip } from "src/components";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import icGlobe from "src/assets/images/ic_globe.svg";
/* 
  외부링크 노출 관리 목록 columns
*/
const columns = [
  {
    Header: "순서",
    accessor: "displayOrderNumber",
    width: 120,
    Cell: ({ row, value, rows, handleChangeOrder }: any) => {
      const exposed = row.original.exposed;
      const priority = row.original.priority;

      // exposed된 항목들만 필터링하고 priority로 정렬
      const exposedItems = rows
        .map((r: any) => r.original)
        .filter((item: CustomLinkModel) => item.exposed)
        .sort((a: CustomLinkModel, b: CustomLinkModel) => (b.priority || 0) - (a.priority || 0));

      const exposedCount = exposedItems.length;
      const currentIndex = exposedItems.findIndex((item: CustomLinkModel) => item.id === row.original.id);

      // up 버튼: displayOrderNumber가 1이면 disabled
      const isUpDisabled = !exposed || value === 1;
      // down 버튼: displayOrderNumber가 exposedCount와 같으면 disabled
      const isDownDisabled = !exposed || value === exposedCount;

      const handleUp = () => {
        if (currentIndex > 0) {
          const targetItem = exposedItems[currentIndex - 1]; // 바로 위 항목
          handleChangeOrder(row.original.id, targetItem.id, priority, targetItem.priority);
        }
      };

      const handleDown = () => {
        if (currentIndex < exposedCount - 1) {
          const targetItem = exposedItems[currentIndex + 1]; // 바로 아래 항목
          handleChangeOrder(row.original.id, targetItem.id, priority, targetItem.priority);
        }
      };

      return (
        <div className="flex-row flex-center gap2">
          <button className={`order-button up`} disabled={isUpDisabled} onClick={handleUp}></button>
          <button className={`order-button down`} disabled={isDownDisabled} onClick={handleDown}></button>
        </div>
      );
    },
  },
  {
    Header: "id",
    accessor: "id",
    width: 80,
    Cell: ({ value }: Cell<CustomLinkModel>) => {
      return <div>{value}</div>;
    },
  },
  {
    Header: "아이콘",
    accessor: "iconMedia",
    width: 80,
    Cell: ({ row, value }: Cell<CustomLinkModel>) => {
      const iconMedia = row.original.icon?.url;
      return <div className="custom-link-list-icon">
        <img src={iconMedia || icGlobe} className="custom-link-list-icon__icon" alt="custom-link-list-icon" />
      </div>;
    },
  },
  {
    Header: "링크명",
    accessor: "name",
    width: 180,
    Cell: ({ value }: Cell<CustomLinkModel>) => {
      return <BaseTooltip className="text-left w-100" isSingleLine contents={value || "-"} />;
    },
  },

  {
    Header: "링크",
    accessor: "url",
    width: 160,
    Cell: ({ value }: Cell<CustomLinkModel>) => {
      return (
        <div className="w-100">
          <BaseNewTabLink path={value} value={value || "-"} ellipsis />
        </div>
      );
    },
  },

  {
    Header: ({ rows }: any) => {
      const exposedCount = rows.filter((r: any) => r.original.exposed).length;
      return <p>{`노출 (${exposedCount}/5)`}</p>;
    },
    accessor: "exposed",
    width: 80,
    Cell: ({ value, row, handleChangeExposed }: any) => {
      const id = row.original.id;

      return (
        <div className="w-100">
          <BaseToggle checked={value} onChange={() => handleChangeExposed?.(id, !value)} />
        </div>
      );
    },
  },
];

export default columns;
